import { render } from "./AppSpinnerDualRing.vue?vue&type=template&id=ccfa370c"
import script from "./AppSpinnerDualRing.vue?vue&type=script&lang=js"
export * from "./AppSpinnerDualRing.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_61b3eac7/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__